<template>
<div>
    <b-modal @ok="descriptionDatasetModalOk" v-model="showModalDataSet" size="xl" centered scrollable no-close-on-backdrop no-close-on-esc >
        <template #modal-title>
            <div class="text-center">
            <p class="text-center w-100">
                Création d'une table de données
            </p>
            </div>
        </template>
        <form v-on:submit.prevent="sendForm">
            <b-form-input
            v-model="textUsername"
            placeholder="Enter Data Name"
            >
            </b-form-input>
            <div
            v-show="enterNameAlert != ''"
            class="alert alert-danger"
            role="alert"
            >
            {{ enterNameAlert }}
            </div>
                <div class="form-row">
                    <div class="w-20 ml-3 mb-3">
                      <label for="exampleFormControlSelect1">Choose DataSet Function</label>
                      <b-form-select v-model="selectedFunction" >
                        <option
                          v-for="item in DescriptionDataSet"
                          v-bind:key="item.FunctionName"
                          v-bind:value="item.FunctionName"
                          @click="functionNameChoose(item.FunctionName)"
                        >
                          {{ item.FunctionName }}
                        </option>
                      </b-form-select>
                      <div
                        v-show="enterDataAlert != ''"
                        class="alert alert-danger"
                        role="alert"
                      >
                        {{ enterDataAlert }}
                      </div>
                      <label> {{ selectedFunction }}    .    {{ dataManagementArray }} </label>
                    </div>
                  </div>
                  <b-row class="p-0">
                    <b-col align-v="center" class="p2-1 col-5">
                      <template v-for="item in CloneDataSet">
                        <b-table-simple
                          responsive
                          v-bind:key="item.FunctionName"
                          v-show="item.FunctionName == selectedFunction"
                        >
                          <b-thead>
                            <b-tr class="text-left">
                              <b-th class="col-8">Paramètre</b-th>
                              <b-th class="col-4">Valeur</b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                        <template v-for="itemParameter in item.Parameters"
                             class="w-100">
                            <b-tr v-for="parameterInfo in itemParameter.Parameter"
                              v-bind:key="parameterInfo.Name"
                              v-show="parameterInfo.Default == true">
                              <b-td >{{ parameterInfo.Name }}</b-td>
                              <b-td class="text-center">
                                <b-form-select
                                  v-show="parameterInfo.TypeName == 'int' || 'long'"
                                >
                                  <option
                                    v-bind:key="parameterInfo.TypeName"
                                    class="w-100"
                                  >
                                    {{ parameterInfo.TypeName }}
                                  </option>
                                </b-form-select>
                                <input
                                    type="checkbox"
                                    class="form-check-input"
                                    v-show="parameterInfo.TypeName == 'bool'"
                                />
                              </b-td>
                            </b-tr>
                            </template>
                            <template v-for="Row in ParameterRow">
                                <b-tr v-if="Row.selectedParameter != ''" v-bind:key="Row"> 
                                <b-td> {{ Row.selectedParameter }}</b-td>
                                <b-td>
                                     <a @click="onDeleteParameterRow(Row.id, Row.selectedParameter)" href="#" >
                                        <b-icon class="text-right" 
                                            style="height: 15px; width: 15px; color: red"
                                            icon="x-circle" 
                                        />
                                    </a>
                                </b-td>
                            </b-tr>
                             </template>
                            <template v-for="newRow in addNewParameterRow">
                                <b-tr v-if="newRow.selectedParameter == ''" v-bind:key="newRow"> 
                                <b-td> 
                                    <template v-for="itemParameter in item.Parameters">
                                        <b-form-select v-bind:key="itemParameter" v-model="itemDataParameterSelected" >
                                        <option v-for="item in itemParameter.Parameter" v-bind:key="item.Name" @click="sendFormSelect(item.Name, item.TypeName)" v-show="item.Default == false">
                                            {{ item.Name }}
                                        </option>
                                        </b-form-select>
                                    </template>
                                </b-td>
                                <b-td>
                                    <a @click="onSelectParameterRow(newRow.id, itemDataParameterSelected)" href="#" >
                                        <b-icon class="text-right" 
                                            style="height: 15px; width: 15px; color: green"
                                            icon="check-circle" 
                                        />
                                    </a>
                                </b-td>
                            </b-tr>
                            </template>
                             <div
                                v-show="isEmptyParameterAlert != ''"
                                class="alert alert-danger"
                                role="alert"
                                >
                                {{ isEmptyParameterAlert }}
                                </div>
                            <b-tr>
                                <b-td colspan="2" class="text-center">
                                    <label v-for="item in dataManagementArray" v-bind:key="item.dataType"> Management Array :  {{ item.dataType }}</label>
                                <a
                                    @click="onAddParameterRow()" 
                                    href="#"
                                >
                                    <b-icon
                                    class="text-right"
                                    style="height: 15px; width: 15px; color: green"
                                    icon="plus-circle"
                                    />
                                </a>
                                </b-td>
                            </b-tr>                              
                          </b-tbody>
                        </b-table-simple>
                      </template>
                    </b-col>
                    <b-col class="p-0 col-2"> </b-col>
                    <b-col class="pr-2 col-5">
                      <template v-for="item in CloneDataSet">
                        <b-table-simple
                          responsive
                          v-bind:key="item.FunctionName"
                          v-show="item.FunctionName == selectedFunction"
                        >
                          <b-thead>
                            <b-tr class="text-left">
                              <b-th class="col-8">Fields</b-th>
                              <b-th class="col-4">Valeur {{ showModifyModalDataSet }}</b-th>
                            </b-tr>
                          </b-thead>
                          <b-tbody>
                             <template v-for="Row in FieldRow">
                                <b-tr v-if="Row.selectedField != ''" v-bind:key="Row" class="text-left align-middle"> 
                                <b-td> {{ Row.selectedField }}</b-td>
                                <b-td>
                                     <a @click="onDeleteFieldRow(Row.id, Row.selectedField)" href="#" >
                                        <b-icon class="text-right" 
                                            style="height: 15px; width: 15px; color: red"
                                            icon="x-circle" 
                                        />
                                    </a>
                                </b-td>
                            </b-tr>
                             </template>
                            <template v-for="newRow in addNewFieldRow">
                                <b-tr v-if="newRow.selectedField == ''" v-bind:key="newRow" class="text-left align-middle"> 
                                <b-td> 
                                    <template v-for="itemField in item.Fields">
                                        <b-form-select v-bind:key="itemField" v-model="itemDataFieldSelected" >
                                        <option v-for="item in itemField.Field" v-bind:key="item.DataField" @click="sendFormSelect(item.DataField, item.TypeName)" >
                                            {{ item.DataField }}
                                        </option>
                                        </b-form-select>
                                    </template>
                                </b-td>
                                <b-td>
                                    <a @click="onSelectFieldRow(newRow.id, itemDataFieldSelected)" href="#" >
                                        <b-icon style="height: 15px; width: 15px; color: green"
                                            icon="check-circle" 
                                        />
                                    </a>
                                    <!-- <a @click="onDeleteFieldRow(newRow.id, itemDataFieldSelected)" href="#" class="p-1" >
                                        <b-icon class="text-right" 
                                            style="height: 15px; width: 15px; color: red"
                                            icon="x-circle" 
                                        />
                                    </a> -->
                                </b-td>
                            </b-tr>
                            </template>
                            <div
                                v-show="isEmptyFieldAlert != ''"
                                class="alert alert-danger"
                                role="alert"
                                >
                                {{ isEmptyFieldAlert }}
                                </div>
                            
                             <b-tr style="overflow-y: hidden">
                                <b-td colspan="2" class="text-center">
                                <a
                                    @click="onAddFieldRow()" 
                                    href="#"
                                >
                                    <b-icon
                                    class="text-right"
                                    style="height: 15px; width: 15px; color: green"
                                    icon="plus-circle"
                                    />
                                </a>
                                </b-td>
                            </b-tr>                              
                          </b-tbody>
                        </b-table-simple>
                      </template>
                    </b-col>
                  </b-row>           
        </form>
    </b-modal>
    </div>
</template>

<script lang="ts">
import { Component, Vue, Watch, Prop, Provide } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import * as JQuery from "jquery";

@Component({
  components: {
    FontAwesomeIcon,
    JQuery,
  },
})
export default class DescriptionDataSet extends Vue {

    private hideDescriptionDataSetModal: boolean = false;
    private textUsername: string = "";
    private enterNameAlert: string = "";
    private enterDataAlert: string = "";
    private selectedFunction: string = "";
    private itemDataFieldSelected: string = "";
    private isEmptyFieldAlert: string = "";
    private itemDataParameterSelected: string = "";
    private isEmptyParameterAlert: string= "";
    private addNewParameterRow: { id: number; row: boolean; selectedParameter: string; type: string}[] = [];
    private ParameterRow: { id: number; row: boolean; selectedParameter: string; type: string}[] = [];
    private numberAddedParameterRow: number = 0;
    private addNewFieldRow: { id: number; row: boolean; selectedField: string; type: string}[] = [];
    private FieldRow: { id: number; row: boolean; selectedField: string; type: string}[] = [];
    private numberAddedFieldRow: number = 0;
    private dataNameModel: string = "";
    private typeNameModel: string = "";

    private DescriptionDataSet: {
        FunctionName: string;
        Parameters: {
            Parameter: { Name: string; TypeName: string; Default: boolean }[];
        }[];
        Fields: {
            Field: { DataField: string; TypeName: string; }[];
        }[];
    }[] = [
    {
        FunctionName: "Consumption",
        Parameters: [{
            Parameter:[{
                Name: "Ids",
                TypeName: "List<long>",
                Default: true
            },
            {
                Name: "Energies",
                TypeName: "List<int>",
                Default: false
            },
            {
                Name: "Excepted",
                TypeName: "List<int>",
                Default: false
            },
            {
                Name: "Type",
                TypeName: "ObjectTypeEnum",
                Default: false
            },
            {
                Name: "ReferenceYear",
                TypeName: "int",
                Default: true
            },
            {
                Name: "FirstYear",
                TypeName: "int",
                Default: true
            },
            {
                Name: "LastYear",
                TypeName: "int",
                Default: true
            },
            {
                Name: "SumEnergies",
                TypeName: "bool",
                Default: false
            },
            {
                Name: "TotalEnergies",
                TypeName: "bool",
                Default: false
            },
            {
                Name: "TotalCost",
                TypeName: "bool",
                Default: false
            },
            {
                Name: "SlidingYear",
                TypeName: "bool",
                Default: false
            },
            {
                Name: "Estimated",
                TypeName: "bool",
                Default: false
            },
            {
                Name: "Correctors",
                TypeName: "List<int>",
                Default: false
            },
            {
                Name: "ProviderTariffs",
                TypeName: "List<long>",
                Default: false
            },
            {
                Name: "SynthesisType",
                TypeName: "SynthesisTypeEnum",
                Default: false
            },
            {
                Name: "Flow",
                TypeName: "FlowTypeEnum",
                Default: false
            },
            {
                Name: "Periodicity",
                TypeName: "PeriodicityEnum",
                Default: false
            },
            {
                Name: "Distribution",
                TypeName: "SynthesisDistributionEnum",
                Default: false
            },
        ]}]
        ,
        Fields: [{
            Field:[{
                DataField: "PersistentId",
                TypeName: "long"
            },
            {
                DataField: "Type",
                TypeName: "ObjectTypeEnum"
            },
            {
                DataField: "Invariant",
                TypeName: "string"
            },
            {
                DataField: "Name",
                TypeName: "string"
            },
            {
                DataField: "Energy",
                TypeName: "string"
            },
            {
                DataField: "Distribution",
                TypeName: "string"
            },
            {
                DataField: "Year",
                TypeName: "int"
            },
            {
                DataField: "Month",
                TypeName: "int"
            },
            {
                DataField: "Consumption",
                TypeName: "decimal"
            },
            {
                DataField: "RateEP",
                TypeName: "decimal"
            },
            {
                DataField: "RateCO2",
                TypeName: "decimal"
            },
            {
                DataField: "Cost",
                TypeName: "decimal"
            },
            {
                DataField: "DjuConsumption",
                TypeName: "decimal"
            },
            {
                DataField: "DjuRateEP",
                TypeName: "decimal"
            },
            {
                DataField: "DjuRateCO2",
                TypeName: "decimal"
            },
            {
                DataField: "DjuCost",
                TypeName: "decimal"
            }
        ]
        }],
    },
    {
        FunctionName: "Factor",
        Parameters: [{
            Parameter:[{
                "Name": "Id",
                "TypeName": "long",
                "Default": true
            },
            {
                "Name": "NodeId",
                "TypeName": "long",
                "Default": false
            },
            {
                Name: "ObjectTypes",
                TypeName: "List<ObjectTypeEnum>",
                Default: false
            },
            {
                Name: "ReferenceYear",
                TypeName: "int",
                Default: false
            },
            {
                Name: "FirstYear",
                TypeName: "int",
                Default: false
            },
            {
                Name: "LastYear",
                TypeName: "int",
                Default: false
            },
            {
                Name: "Periodicity",
                TypeName: "PeriodicityEnum",
                Default: false
            },
            {
                Name: "WithChildren",
                TypeName: "bool",
                Default: false
            }
            ]
        }],
        Fields: [{
            Field:[
                {
                DataField: "Name",
                TypeName: "string"
            },
            {
                DataField: "Year",
                TypeName: "int"
            },
            {
                DataField: "Month",
                TypeName: "int"
            },
            {
                DataField: "Value",
                TypeName: "decimal"
            },
            {
                DataField: "Weighted",
                TypeName: "bool"
            }
            ]
        }]
    }
    ];

    private CloneDataSet: {
        FunctionName: string;
        Parameters: {
            Parameter: { Name: string; TypeName: string; Default: boolean }[];
        }[];
        Fields: {
            Field: { DataField: string; TypeName: string; }[];
        }[];
    }[] = [];

 if (showModalDataSet) {
        console.log(showModalDataSet);
        console.log("dataManagement : " + this.dataManagementArray);
        this.selectedFunction = this.dataManagementArray[0].dataType;
    }

    private functionNameChoose(FunctionName){
        this.CloneDataSet = [];
        this.FieldRow = [];
        this.ParameterRow = [];
        var desc = this.DescriptionDataSet.find(element => element.FunctionName == FunctionName);
        if (desc)
            this.CloneDataSet.push(desc);
    }

    private sendFormSelect(data, type){
        this.dataNameModel = "";
        this.typeNameModel = "";
        if(data != null && type != null)
        {
            this.dataNameModel = data;
            this.typeNameModel = type;
        }
    }

    private onAddFieldRow(){
        if(this.addNewFieldRow.length < 1)
        {
            this.isEmptyFieldAlert = "";
            this.itemDataFieldSelected = "";
            this.addNewFieldRow.push( {id: this.numberAddedFieldRow++, row: true, selectedField: "", type: "" } );
        }
        else{
            this.isEmptyFieldAlert = "Veuillez valider la première ligne ";
        }
    }

    private onSelectFieldRow(id){
        if(this.dataNameModel != ""){
            this.isEmptyFieldAlert = "";
        // affectation de listField puis push dans Fieldrow
            var field = this.addNewFieldRow.find(element => element.id == id);
            if(field) {
                field.selectedField = this.dataNameModel;
                field.type = this.typeNameModel;
                this.FieldRow.push(field);

            // splice de addNewRow
                this.addNewFieldRow.splice(this.addNewFieldRow.indexOf(id), 1);
            // splice de la ligne de field pour qu'elle n'apparaisse plus dans le select
                this.CloneDataSet[0].Fields[0].Field.splice(this.CloneDataSet[0].Fields[0].Field.findIndex(element => element.DataField == this.dataNameModel),1);
            }
        } else {
            this.isEmptyFieldAlert = "Veuillez selectionner une donnée";
        }
    }

    private onDeleteFieldRow(id, listField){
        this.isEmptyFieldAlert = "";
        if(listField != ""){
            var field = this.FieldRow.find(element => element.selectedField == listField);
            if (field)
            {
                const rowDataField = field.selectedField;
                const rowTypeField = field.type;
            
                this.CloneDataSet[0].Fields[0].Field.push({ DataField: rowDataField, TypeName: rowTypeField });

                var index = this.FieldRow.findIndex(element => element.id == id);
                this.FieldRow.splice(index, 1);
            }
        }
    }

    private onSelectParameterRow(id){
        if(this.dataNameModel != ""){
            this.isEmptyParameterAlert = "";
        // affectation de listField puis push dans les row
            var field = this.addNewParameterRow.find(element => element.id == id);
            if (field) {
                field.selectedParameter = this.dataNameModel;
                field.type = this.typeNameModel;
                this.ParameterRow.push(field);
            // splice de new row
                this.addNewParameterRow.splice(this.addNewParameterRow.indexOf(id), 1);
            // splice de la ligne de field pour qu'elle n'apparaisse plus dans le select
                this.CloneDataSet[0].Parameters[0].Parameter.splice(this.CloneDataSet[0].Parameters[0].Parameter.findIndex(element => element.Name == this.dataNameModel),1);
            }
        } else {
            this.isEmptyParameterAlert = "Veuillez selectionner une donnée";
        }
    }

    private onAddParameterRow(){
        if(this.addNewParameterRow.length < 1)
        {
            this.isEmptyParameterAlert = "";
            this.itemDataParameterSelected = "";
            this.addNewParameterRow.push( {id: this.numberAddedParameterRow++, row: true, selectedParameter: "", type: "" } );
        }
        else{
            this.isEmptyParameterAlert = "Veuillez valider la première ligne ";
        }
    }

    private onDeleteParameterRow(id, listParameter){
          this.isEmptyParameterAlert = "";
        if(listParameter != ""){
            var param = this.ParameterRow.find(element => element.selectedParameter == listParameter);
            if (param)
            {
                const rowDataParameter = param.selectedParameter;
                const rowTypeParameter = param.type;
                this.CloneDataSet[0].Parameters[0].Parameter.push({ Name: rowDataParameter, TypeName: rowTypeParameter, Default: false});
                
                var index = this.ParameterRow.findIndex(element => element.id == id);
                this.ParameterRow.splice(index, 1);
            }
        }
    }

    private descriptionDatasetModalOk(){
        this.$emit('hideDescriptionDataSetModal', this.textUsername, this.selectedFunction);
    }

    
  @Prop()
  showModalDataSet!: boolean;
  
  @Prop()
  showModifyModalDataSet!: boolean;

  @Prop()
  dataManagementArray!: { dataName: string; dataType: string}[];

}
</script>

<style scoped>
</style>